import { render, staticRenderFns } from "./arwTenant.vue?vue&type=template&id=39396dae&"
import script from "./arwTenant.vue?vue&type=script&lang=js&"
export * from "./arwTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports